import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=18168678&scoped=true"
import script from "./slider.vue?vue&type=script&lang=ts"
export * from "./slider.vue?vue&type=script&lang=ts"
import style0 from "./slider.vue?vue&type=style&index=0&id=18168678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18168678",
  null
  
)

export default component.exports